import { cn, type WithClassNameAndChildren } from "~/lib/utils";

import { Spinner } from "../assets/spinner";

import { Screen } from "./screen";

const ScreenLoaderRoot = ({
  children,
  className
}: WithClassNameAndChildren) => {
  return (
    <Screen className={cn("bg-interface-neutral-4", className)}>
      <Screen.Visual className="my-16">
        <Spinner />
      </Screen.Visual>

      <Screen.Content>{children}</Screen.Content>
    </Screen>
  );
};

// Namespace pattern export
export const ScreenLoader = Object.assign(ScreenLoaderRoot, {
  Title: Screen.Title,
  Text: ({ className, ...props }: WithClassNameAndChildren) => (
    <Screen.Text
      className={cn("text-interface-neutral-6", className)}
      {...props}
    />
  ),
  Button: Screen.Button
});
